const PRIVACY_PORTAL_HOSTS = new Set([
  'privacy.zillowgroup.com',
  'www.privacy.zillowgroup.com',
  'coreprivacy-stable.zg-int.net',
  'coreprivacy-dev.zg-int.net',
]);

const PRIVACY_PORTAL_SSO_PATH = '/hotpadsSSO';

export const PRIVACY_PORTAL_SSO_URL = 'https://privacy.zillowgroup.com/hotpadsSSO';
export const PRIVACY_PORTAL_COMPLETION_PATH = '/privacy-portal/complete';
export const PRIVACY_PORTAL_MANAGE_PATH = '/privacy-portal/manage';

export function sanitizePrivacyPortalRedirect(value: unknown): string | null {
  if (typeof value !== 'string') return null;

  let redirectUrl: URL;
  try {
    redirectUrl = new URL(value);
  } catch {
    return null;
  }

  if (
    redirectUrl.protocol !== 'https:' ||
    !PRIVACY_PORTAL_HOSTS.has(redirectUrl.hostname) ||
    redirectUrl.pathname !== PRIVACY_PORTAL_SSO_PATH ||
    redirectUrl.port ||
    redirectUrl.username ||
    redirectUrl.password ||
    redirectUrl.hash
  ) {
    return null;
  }

  return redirectUrl.toString();
}

export function getPrivacyPortalCompletionRedirect(value: unknown): string | null {
  const redirectUrl = sanitizePrivacyPortalRedirect(value);
  if (!redirectUrl) return null;

  return `${PRIVACY_PORTAL_COMPLETION_PATH}?${new URLSearchParams({ redirectUrl })}`;
}
